import { z } from "zod";
import { accrualPolicyEmployeeSchema } from "../accrual-policy/schemas/accrualPolicyEmployeeSchema";
import { baseEventInput } from "./baseEvent";

export const accrualPolicyEmployeeEvent = baseEventInput.extend({
  source: z.literal("accrualpolicyemployees"),
  employeeId: z.string(),
  companyId: z.string(),
  accrualPolicyEmployeeId: z.string(),
  employeeCheckIds: z.array(z.string()).default([]),
  payload: accrualPolicyEmployeeSchema.partial(),
});

export type AccrualPolicyEmployeeEvent = z.infer<
  typeof accrualPolicyEmployeeEvent
>;
